import queryEncodeObject from '@/utils/Encoders/queryEncodeObject'

function queryEncodeArray(arr) {
  if (typeof arr[0] === 'object') {
    return (
      arr[0].length !== undefined ? arr.map(queryEncodeArray) : arr.map(queryEncodeObject)
    ).join(',')
  }
  return arr.join(',')
}

export default queryEncodeArray
